import snapshot from "@/generated/db-posts.json";

/**
 * Build-time snapshot of the weekly auto-generated blog posts.
 * Written by scripts/fetch-db-posts.ts before every build so these posts
 * prerender to real HTML instead of a client-only shell.
 */
export interface PrebuiltPost {
  slug: string;
  title: string;
  excerpt: string | null;
  meta_description: string | null;
  category: string | null;
  content: string;
  published_at: string;
  updated_at: string | null;
  hero_image_url: string | null;
}

export const PREBUILT_DB_POSTS = snapshot as PrebuiltPost[];

export const PREBUILT_DB_SLUGS = PREBUILT_DB_POSTS.map((p) => p.slug);

export function getPrebuiltPost(slug?: string): PrebuiltPost | undefined {
  if (!slug) return undefined;
  return PREBUILT_DB_POSTS.find((p) => p.slug === slug);
}
